import React from 'react';
import { Tabs, Tab, Box, Paper } from '@mui/material';
import { FilterItem } from '../../../../types/sales';

// タブ切り替えコンポーネントの定義
interface SupervisorTabsProps {
  supervisors: FilterItem[];
  selectedSupervisor: string;
  onSupervisorChange: (supervisor: string) => void;
}

export const SupervisorTabs: React.FC<SupervisorTabsProps> = ({
  supervisors,
  selectedSupervisor,
  onSupervisorChange
}) => {
  return (
    <Paper 
      elevation={3} 
      sx={{ 
        mb: 3,
        borderRadius: '8px',
        overflow: 'hidden',
        border: '1px solid #e0e0e0'
      }}
    >
      <Box 
        sx={{ 
          bgcolor: '#4CAF50', 
          color: 'white', 
          py: 1, 
          px: 2, 
          fontWeight: 'bold',
          fontSize: '0.9rem'
        }}
      >
        担当者を選択
      </Box>
      <Tabs
        value={selectedSupervisor || "all"}
        onChange={(_, newValue) => onSupervisorChange(newValue === "all" ? "" : newValue)}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="担当者タブ"
        sx={{
          backgroundColor: '#f8f8f8',
          '& .MuiTabs-indicator': {
            backgroundColor: '#4CAF50',
            height: 3,
          },
          '& .MuiTab-root': {
            transition: 'all 0.2s',
            minHeight: '48px',
            fontSize: '0.875rem',
            '&:hover': {
              backgroundColor: '#f0f7f0',
            },
          }
        }}
      >
        {supervisors.map((supervisor) => (
          <Tab
            key={supervisor.name}
            label={supervisor.name}
            value={supervisor.name}
            sx={{
              fontWeight: selectedSupervisor === supervisor.name ? 'bold' : 'normal',
              '&.Mui-selected': {
                color: '#4CAF50',
                backgroundColor: '#e8f5e9',
              },
            }}
          />
        ))}
        {/* 「全担当」タブを一番右に配置 */}
        <Tab
          label="全担当"
          value="all"
          sx={{
            fontWeight: selectedSupervisor === "" ? 'bold' : 'normal',
            '&.Mui-selected': {
              color: '#4CAF50',
              backgroundColor: '#e8f5e9',
            },
          }}
        />
      </Tabs>
    </Paper>
  );
};